<div class="no-data-container">
  <img [src]="icon" [style.width]="iconSize" [style.height]="iconSize" alt="No data icon">
  <span class="no-data-title">{{ title }}</span>
  <span class="no-data-message">{{ message }}</span>
</div>

